/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { getJson } from 'session';
import { ModalContext } from 'App';
import moment from 'moment';
import CmsContext from 'context/CmsContext';
import { Acl } from 'modules/common/components/Acl';
import { flatIncludedToItem } from 'api/actions';
import Pagination from 'modules/common/components/Pagination';
import ViewReceipt from './components/ViewReceipt';
// import { numberFormat } from 'helper';
import ChangeTxn from './components/ChangeTxn';
import ViewPaymentLogs from './components/ViewPaymentLogs';
import ChangeAmount from './components/ChangeAmount';
import ChangeYear from './components/ChangeYear';
import ChangeQuarter from './components/ChangeQuarter';
import ManualPaymentModal from './components/ManualPaymentModal';
import ChangeReferenceNumber from './components/ChangeReferenceNumber';
import ViewOR from 'modules/BPLS/container/applications/components/ViewOR';
import PaymentPostingModal from './components/PaymentPostingModal';
import RollbackModal from './components/RollbackModal';
import * as action from './actions';
import * as c from './constants';

const INIT_FILTER = {
  transaction_status: '',
  q: '',
  module_type: '',
  sort_by: 'desc',
};

function PaymentInquiryContainer({
  getListCms,
  getPaperList,
  // itemHtml,
  // itemPaperHtml,
  findPayment,
  searching,
  tagAsForPosting,
  posting,
  findingLogs,
  viewPaymentLogs,
  findingLogsForTxn,
  viewPaymentLogsForTxn,
  permissions,
  postPaymentToQpax,
  manualExpireRefno,
  approveRefund,
  refunding,
  viewPaymentLogsForAmount,
  findingLogsForAmount,
  postEgovPay,
  isPostingEgovPay,
  history,
  location,
  rollbackPayment,
  getFeeOptionList,
  getFindPaymentList,
  findPaymentList,
  findPaymentPager,
  isLoading,
  findPaymentById,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const [formData, setFormData] = useState(INIT_FILTER);

  const TYPE = 'OFFICIAL_RECEIPT';
  const PAPER_TYPE = 'BUSINESS_PERMIT_PAPER_SETUP';

  useEffect(() => {
    getListCms({ type: TYPE });
    getPaperList({ type: PAPER_TYPE });
    getFindPaymentList({ ...INIT_FILTER, page: 1 });
  }, []);

  // const permitList = JSON.parse(_.get(itemHtml, 'attributes.body') || '[]');
  // const defaultIndex = (permitList || [])?.findIndex(
  //   (permit) => permit.selected || 0
  // );

  // const contentData =
  //   (JSON.parse(_.get(itemHtml, 'attributes.body') || '{}')[defaultIndex] || {})
  //     .body ?? '';

  // const paperSetupData = JSON.parse(
  //   _.get(itemPaperHtml, 'attributes.body') || '{}'
  // );

  // const generatePrintStyles = (settings) => {
  //   const {
  //     bottom,
  //     left,
  //     paper_margin,
  //     paper_orientation,
  //     paper_size,
  //     right,
  //     top,
  //   } = settings;

  //   const pageSize = paper_size === 'A4' ? 'A4' : paper_size; // Default to provided size
  //   const orientation =
  //     paper_orientation === 'portrait' ? 'portrait' : 'landscape';

  //   return `
  //       <style>
  //         @page {
  //           size: ${pageSize} ${orientation};
  //           margin: ${top}${paper_margin} ${right}${paper_margin} ${bottom}${paper_margin} ${left}${paper_margin};
  //         }
  //       </style>
  //     `;
  // };

  const [paymentInfo, setPaymentInfo] = useState({});
  const [taxPayerInfo, setTaxPayerInfo] = useState({});
  const [taxPayerInfoIsPosted, setTaxPayerInfoIsPosted] = useState('');
  const [transId, setTransId] = useState({});
  const [item, setItem] = useState({});
  const paymentInfoTransactionType = _.get(paymentInfo, 'transaction_type', '');
  const taxpayerInfoBrgyClearanceStatus = _.get(
    taxPayerInfoIsPosted,
    'barangay_clearance_status',
    ''
  );
  const isNewRenew =
    paymentInfoTransactionType === 'NEW' ||
    paymentInfoTransactionType === 'RENEWAL';

  const formatNumber = (value) => {
    const numberValue = parseFloat(value);

    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: false,
    }).format(numberValue);
  };

  const handleFindPaymentResponse = (res) => {
    const itemData = flatIncludedToItem(
      _.get(res, 'res.data') || [],
      _.get(res, 'res.included') || []
    );

    const transactionId = _.get(itemData, 'id', 0);

    if (transactionId) {
      getFeeOptionList(transactionId, {}, ({ res: feeOptionRes }) => {
        const itemsArray = Array.isArray(feeOptionRes)
          ? feeOptionRes
              .filter((val) => parseFloat(_.get(val, 'amount', 0)) !== 0)
              .map((val) => {
                const name = _.get(val, 'name');
                const amount = formatNumber(_.get(val, 'amount'));
                const year = _.get(val, 'year');
                const feeOption = [name, amount, year].filter(Boolean).join(' | ');

                return { label: feeOption, value: feeOption };
              })
          : [];

        localStorage.setItem('feesItems', JSON.stringify(itemsArray));
      });
    } else {
      localStorage.setItem('feesItems', JSON.stringify([]));
    }

    localStorage.setItem(
      'permit_type',
      _.get(res, 'res.data.attributes.permit_type')
    );
    localStorage.setItem('refno', JSON.stringify(formData));
    localStorage.setItem('itemData', JSON.stringify(itemData));
    localStorage.setItem('transId', _.get(res, 'res.data.id'));
    localStorage.setItem(
      'amount_with_or',
      _.get(res, 'res.data.attributes.amount_with_or')
    );
    localStorage.setItem(
      'amount_without_or',
      _.get(res, 'res.data.attributes.amount_without_or')
    );
    localStorage.setItem(
      'total_amount',
      _.get(res, 'res.data.attributes.amount')
    );

    setItem(itemData);
    setTransId(_.get(res, 'res.data.id'));
    setPaymentInfo(_.get(res, 'res.data.attributes') || {});
    setTaxPayerInfo(_.get(res, 'res.included[0].attributes') || {});
    setTaxPayerInfoIsPosted(
      _.get(res, 'res.included[1].attributes') || ''
    );
  };

  useEffect(() => {
    const restoreTransactionId = _.get(location, 'state.restoreTransactionId');
    if (!restoreTransactionId) return undefined;
    findPaymentById(restoreTransactionId, handleFindPaymentResponse);
    history.replace({
      pathname: _.get(location, 'pathname'),
      state: {},
    });
    return undefined;
  }, [_.get(location, 'state.restoreTransactionId')]);

  const handleFindPayment = () => {
    findPayment(formData, handleFindPaymentResponse);
  };

  const onFindPayment = (e) => {
    e.preventDefault();
    setPaymentInfo({});
    getFindPaymentList({ ...formData, page: 1 });
  };
  const handleFilter = () => {
    setPaymentInfo({});
    getFindPaymentList({ ...formData, page: 1 });
  };

  const handleChangeFindPaymentPage = (page) => {
    getFindPaymentList({ ...formData, page });
  };

  const handleViewFindPayment = (listItem) => () => {
    const transactionId = _.get(listItem, 'id');
    const selectedRefNo =
      _.get(listItem, 'attributes.refno') ||
      _.get(listItem, 'attributes.txnid') ||
      '';
    const selectedModuleType =
      _.get(listItem, 'attributes.module_type') || _.get(formData, 'module_type');

    const payload = {
      ...formData,
      refno: selectedRefNo,
      module_type: selectedModuleType,
    };

    setFormData(payload);
    findPaymentById(transactionId, handleFindPaymentResponse);
  };

  const handlePostPaymentToQpax = (e) => {
    e.preventDefault();
    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };
    postPaymentToQpax(args, (res) => {
      const msg = _.get(res, 'res.res.message');
      if (msg === 'This transaction is already posted.') {
        setPaymentInfo({
          ...paymentInfo,
          transaction_status: 'PAID',
        });
      }
    });
  };

  const handleViewReceipt = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewReceipt receiptUrl={data} />,
      title: 'View Uploaded Receipt',
      modalSize: 'modal-md',
    });
  };

  const handleClear = (e) => {
    e.preventDefault();
    setFormData({
      q: '',
    });
    setPaymentInfo('');
  };

  const handleBackToList = () => {
    setPaymentInfo({});
    setFormData({});
    getFindPaymentList({ page: 1 });
  };

  const handleChangeTxn = (e) => {
    e.preventDefault();

    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };

    viewPaymentLogsForTxn(args, (res) => {
      setModal({
        isOpen: true,
        content: (
          <ChangeTxn transactionId={transId} logs={res} onClear={handleClear} />
        ),
        title: 'Change TXNID',
        modalSize: 'modal-md',
      });
    });
  };

  const handleChange = (e) => {
    if (_.get(formData, 'q') !== e.target.value) {
      setFormData({
        q: '',
      });
      setPaymentInfo('');
    }
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleViewPaymentLogs = (e) => {
    e.preventDefault();
    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };

    viewPaymentLogs(args, (res) => {
      setModal({
        isOpen: true,
        content: (
          <ViewPaymentLogs
            logs={_.get(res, 'res.data')}
            paymentLogs={_.get(res, 'res.res.transactions')}
          />
        ),
        title: 'View Payment Logs',
        modalSize: 'modal-xl',
      });
    });
  };

  const handleTagforPosting = (e) => {
    e.preventDefault();
    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };
    tagAsForPosting(args, (res) => {
      const msg = _.get(res, 'res.res.message');
      if (msg === 'Transaction is now ready for posting!') {
        setPaymentInfo({
          ...paymentInfo,
          transaction_status: 'WAITING FOR PAYMENT',
        });
      }
    });
  };

  const handleManualExpireRefno = (e) => {
    e.preventDefault();
    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };
    manualExpireRefno(args);
  };

  const handleApproveRefund = (e) => {
    e.preventDefault();
    const args = {
      refno: _.get(paymentInfo, 'txnid'),
    };
    approveRefund(args, () => {
      findPayment(args, (res) => {
        setTransId(_.get(res, 'res.data.id'));
        setPaymentInfo(_.get(res, 'res.data.attributes') || {});
        setTaxPayerInfo(_.get(res, 'res.included[0].attributes') || {});
        setTaxPayerInfoIsPosted(
          _.get(res, 'res.included[1].attributes') || ''
        );
      });
    });
  };

  const handleChangeAmount = (e) => {
    e.preventDefault();

    const args = {
      refno: _.get(paymentInfo, 'txnid'),
    };

    viewPaymentLogsForAmount(args, (res) => {
      setModal({
        isOpen: true,
        content: (
          <ChangeAmount
            transactionId={transId}
            logs={res}
            onClear={handleClear}
          />
        ),
        title: 'Change Amount',
        modalSize: 'modal-md',
      });
    });
  };

  const handleChangeYear = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <ChangeYear
          transactionId={transId}
          onClear={handleClear}
          taxPayerInfoIsPosted={taxPayerInfoIsPosted}
        />
      ),
      title: 'Change Year',
      modalSize: 'modal-md',
    });
  };

  const handleChangeQuarter = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <ChangeQuarter
          transactionId={transId}
          onClear={handleClear}
          taxPayerInfoIsPosted={taxPayerInfoIsPosted}
        />
      ),
      title: 'Change Quarter',
      modalSize: 'modal-md',
    });
  };

  const handleChangeManualPayment = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <ManualPaymentModal
          transactionId={transId}
          onClear={handleClear}
          transactionInfo={paymentInfo}
        />
      ),
      title: 'Manual Payment',
      modalSize: 'modal-md',
    });
  };

  // const convertToWords = (amount) => {
  //   // Arrays for ones, tens, and the thousands
  //   const ones = [
  //     '',
  //     'One',
  //     'Two',
  //     'Three',
  //     'Four',
  //     'Five',
  //     'Six',
  //     'Seven',
  //     'Eight',
  //     'Nine',
  //     'Ten',
  //     'Eleven',
  //     'Twelve',
  //     'Thirteen',
  //     'Fourteen',
  //     'Fifteen',
  //     'Sixteen',
  //     'Seventeen',
  //     'Eighteen',
  //     'Nineteen',
  //   ];
  //   const tens = [
  //     '',
  //     '',
  //     'Twenty',
  //     'Thirty',
  //     'Forty',
  //     'Fifty',
  //     'Sixty',
  //     'Seventy',
  //     'Eighty',
  //     'Ninety',
  //   ];
  //   const thousands = ['', 'Thousand', 'Million', 'Billion']; // Scale array for thousands, millions, etc.

  //   // Function to convert numbers less than 1000 into words
  //   const convertHundreds = (num) => {
  //     let word = '';
  //     if (num >= 100) {
  //       word += ones[Math.floor(num / 100)] + ' Hundred ';
  //       num %= 100;
  //     }
  //     if (num >= 20) {
  //       word += tens[Math.floor(num / 10)] + ' ';
  //       num %= 10;
  //     }
  //     if (num > 0) {
  //       word += ones[num] + ' ';
  //     }
  //     return word.trim();
  //   };

  //   // Handle the case when amount is zero
  //   if (amount === 0) return 'Zero Pesos Only';

  //   // Remove commas and handle float to integer conversion
  //   let wholePart = Math.floor(amount); // Get the whole part (before decimal)
  //   let fractionalPart = Math.round((amount - wholePart) * 100); // Get the fractional part (after decimal)

  //   let result = '';

  //   // Handle numbers larger than 999
  //   let thousandPart = Math.floor(wholePart / 1000);
  //   let hundredPart = wholePart % 1000;

  //   if (thousandPart > 0) {
  //     result += convertHundreds(thousandPart) + ' ' + thousands[1] + ' '; // Convert thousands part
  //   }

  //   // Handle the hundreds part
  //   if (hundredPart > 0) {
  //     result += convertHundreds(hundredPart);
  //   }

  //   result += ' Pesos';

  //   // Handle the fractional part (centavos)
  //   if (fractionalPart > 0) {
  //     result += ` and ${convertHundreds(fractionalPart)} Centavos`;
  //   }

  //   result += ' Only';

  //   return result.trim();
  // };

  // const handleViewOr = (e) => {
  //   e.preventDefault();
  //   const fees = _.get(item, 'included.bplsPermitFees', []);

  //   const generateTable = (fees) => {
  //     let tableHtml = `<table style="border-collapse: collapse; width: 100.337%; height: 102px; border-width: 1px; border-style: none;" border="1">
  //     <colgroup>
  //       <col style="width: 100.4042%;">
  //       <col style="width: 25.6093%;">
  //     </colgroup>
  //     <tbody>`;

  //     fees.forEach((item) => {
  //       if (_.get(item, 'attributes.total_human', '') !== '0.00') {
  //         tableHtml += `
  //         <tr style="height: 20.4px;">
  //           <td style="text-align: left; border-style: none;"><span style="font-size: 10pt;">${_.get(
  //             item,
  //             'attributes.description',
  //             ''
  //           )}</span></td>
  //           <td style="text-align: left; border-style: none;"><span style="font-size: 10pt;">${_.get(
  //             item,
  //             'attributes.total_human',
  //             ''
  //           )}</span></td>
  //         </tr>`;
  //       }
  //     });

  //     // Close table tags
  //     tableHtml += `
  //     </tbody>
  //   </table>`;

  //     return tableHtml;
  //   };

  //   const bplsBusiness = _.get(item, 'included.bplsBusiness.attributes', {});
  //   const bplsPermitApplication = _.get(
  //     item,
  //     'included.bplsApplication.attributes',
  //     {}
  //   );
  //   const transaction = _.get(item, 'attributes', {});

  //   const amountString = _.get(transaction, 'amount', 0);
  //   const cleanedAmount = parseFloat(amountString.replace(/,/g, ''));
  //   const amountInWords = convertToWords(cleanedAmount);

  //   const combinedData = {
  //     ...bplsBusiness,
  //     ...transaction,
  //     ...bplsPermitApplication,
  //     ...{
  //       issuance_date_day: '',
  //       issuance_date_month: '',
  //       issuance_date_year: '',
  //       issuance_days_of_week: '',
  //       validity_date: '',
  //       issuance_date: '',
  //       fees: [],
  //       designation: '',
  //       signatory_1_name: '',
  //       signatory_1_designation: '',
  //       signatory_1_signature: '',
  //       signatory_2_name: '',
  //       signatory_2_designation: '',
  //       signatory_2_signature: '',
  //       signatory_3_name: '',
  //       signatory_3_designation: '',
  //       signatory_3_signature: '',
  //     },
  //   };

  //   let htmlString = contentData;

  //   // 1. Remove any borders from the `style` attributes of tables and cells (td, th)
  //   htmlString = htmlString.replace(
  //     /style="([^"]*?)border[^"]*?"/g,
  //     (match) => {
  //       // Ensure `border:none;` and `border-style:hidden;` is applied to all `style` attributes containing borders
  //       return match
  //         .replace(/border[^:]*?:[^;]*;/g, 'border:none;')
  //         .replace(/border-style[^:]*?:[^;]*;/g, 'border-style:hidden;');
  //     }
  //   );

  //   // 2. Set border to `none` for explicit `border` attributes in tables, td, th, tr
  //   htmlString = htmlString.replace(/border="[^"]*"/g, 'border-style="none"');

  //   // 3. Hide all images by setting display:none
  //   htmlString = htmlString.replace(
  //     /<img[^>]*>/g,
  //     '<img style="visibility:hidden" />'
  //   );

  //   // 4. Apply `border:none;` and `border-style:hidden;` to all table, td, th, and tr elements
  //   htmlString = htmlString.replace(/<table[^>]*>/g, (match) => {
  //     return match.replace(/style="([^"]*?)"/g, (style) => {
  //       return style
  //         ? style
  //             .replace(/border[^:]*?:[^;]*;/g, 'border:none;')
  //             .replace(/border-style[^:]*?:[^;]*;/g, 'border-style:hidden;')
  //         : 'style="border:none; border-style:hidden;"';
  //     });
  //   });

  //   htmlString = htmlString.replace(/<td[^>]*>/g, (match) => {
  //     return match.replace(/style="([^"]*?)"/g, (style) => {
  //       return style
  //         ? style
  //             .replace(/border[^:]*?:[^;]*;/g, 'border:none;')
  //             .replace(/border-style[^:]*?:[^;]*;/g, 'border-style:hidden;')
  //         : 'style="border:none; border-style:hidden;"';
  //     });
  //   });

  //   htmlString = htmlString.replace(/<th[^>]*>/g, (match) => {
  //     return match.replace(/style="([^"]*?)"/g, (style) => {
  //       return style
  //         ? style
  //             .replace(/border[^:]*?:[^;]*;/g, 'border:none;')
  //             .replace(/border-style[^:]*?:[^;]*;/g, 'border-style:hidden;')
  //         : 'style="border:none; border-style:hidden;"';
  //     });
  //   });

  //   // 5. Set `border-collapse: collapse;` to `border-collapse: separate;` to ensure borders do not appear
  //   htmlString = htmlString.replace(
  //     /style="([^"]*?)border-collapse:collapse;?([^"]*?)"/g,
  //     'style="border-collapse: separate;"'
  //   );
  //   htmlString = htmlString
  //     .replace(/<strong[^>]*>/g, '<strong style="visibility:hidden">')
  //     .replace(/<\/strong>/g, '</strong>');

  //   htmlString = htmlString.replace(/\[amount_in_words\]/g, amountInWords);

  //   const values = JSON.parse(
  //     JSON.stringify(combinedData, (key, value) =>
  //       value === null ? 'N/A' : value
  //     )
  //   );

  //   htmlString = htmlString.replace(
  //     /\[no_of_employees_residing_area\]/g,
  //     '[no_of_employees_residing_manila]'
  //   );
  //   htmlString = htmlString.replace(/\[issuance_date\]/g, '[or_generated_at]');
  //   htmlString = htmlString.replace(/\[or_date\]/g, '[transaction_date]');
  //   htmlString = htmlString.replace(/\[owner_address\]/g, '[address]');
  //   htmlString = htmlString.replace(
  //     /\[business_address\]/g,
  //     '[display_address]'
  //   );
  //   htmlString = htmlString.replace(/\[area_formatted\]/g, '[area_human]');
  //   htmlString = htmlString.replace(
  //     /\[capital_amount_formatted\]/g,
  //     '[capital_amount_human]'
  //   );
  //   htmlString = htmlString.replace(
  //     /\[monthly_rental_formatted\]/g,
  //     '[monthly_rental_human]'
  //   );
  //   htmlString = htmlString.replace(
  //     /\[tax_credit_formatted\]/g,
  //     '[tax_credit_human]'
  //   );

  //   htmlString = htmlString.replace(/\[or_no\]/g, '[refno]');

  //   htmlString = htmlString.replace(
  //     /\[business_status\]/g,
  //     '[transaction_type]'
  //   );

  //   htmlString = htmlString.replace(/\[amount\]/g, '[amount_human]');

  //   const replacePlaceholders = (html, values) => {
  //     let updatedHtml = html;

  //     for (const key in values) {
  //       if (Object.hasOwnProperty.call(values, key)) {
  //         const tag = `[${key}]`;
  //         let replacementValue = values[key];

  //         if (key === 'issuance_date_day') {
  //           replacementValue = moment(combinedData.or_generated_at).format(
  //             'DD'
  //           );
  //         }

  //         if (key === 'issuance_date_month') {
  //           replacementValue = moment(combinedData.or_generated_at).format(
  //             'MMMM'
  //           );
  //         }

  //         if (key === 'issuance_date_year') {
  //           replacementValue = moment(combinedData.or_generated_at).format(
  //             'YYYY'
  //           );
  //         }

  //         if (key === 'issuance_days_of_week') {
  //           replacementValue = moment(combinedData.or_generated_at).format(
  //             'dddd'
  //           );
  //         }

  //         if (key === 'validity_date') {
  //           replacementValue = moment().endOf('year').format('DD MMM YYYY');
  //         }

  //         if (key === 'qr_url') {
  //           replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${values[key]}" alt="" width="111" height="111"></span></strong></p>`;
  //         }

  //         if (key === 'fees') {
  //           replacementValue = generateTable(fees);
  //         }

  //         if (key === 'activities') {
  //           replacementValue = generateActivities(bplsActivitiesArray);
  //         }

  //         if (key === 'signatory_1_name') {
  //           replacementValue = _.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_ONE_NAME',
  //             ''
  //           );
  //         }

  //         if (key === 'signatory_1_designation') {
  //           replacementValue = _.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_ONE_DESIGNATION',
  //             ''
  //           );
  //         }

  //         if (key === 'signatory_1_signature') {
  //           replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_ONE_SIGNATURE',
  //             ''
  //           )}" alt="" width="111" height="111"></span></strong></p>`;
  //         }

  //         if (key === 'signatory_2_name') {
  //           replacementValue = _.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_TWO_NAME',
  //             ''
  //           );
  //         }

  //         if (key === 'signatory_2_designation') {
  //           replacementValue = _.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_TWO_DESIGNATION',
  //             ''
  //           );
  //         }

  //         if (key === 'signatory_2_signature') {
  //           replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_TWO_SIGNATURE',
  //             ''
  //           )}" alt="" width="111" height="111"></span></strong></p>`;
  //         }

  //         if (key === 'signatory_3_name') {
  //           replacementValue = _.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_THREE_NAME',
  //             ''
  //           );
  //         }

  //         if (key === 'signatory_3_designation') {
  //           replacementValue = _.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_THREE_DESIGNATION',
  //             ''
  //           );
  //         }

  //         if (key === 'signatory_3_signature') {
  //           replacementValue = `<p><strong><span style="font-size: 10pt;"><img style="display: block; margin-left: auto; margin-right: auto;" src="${_.get(
  //             CMS_COMPONENTS,
  //             'BPLS_SIGNATORY_THREE_SIGNATURE',
  //             ''
  //           )}" alt="" width="111" height="111"></span></strong></p>`;
  //         }

  //         updatedHtml = updatedHtml.split(tag).join(replacementValue);
  //       }
  //     }

  //     return updatedHtml;
  //   };

  //   const legalPaperCss = generatePrintStyles(paperSetupData);

  //   const updatedHtmlString = replacePlaceholders(htmlString, values);

  //   const printWindow = window.open();
  //   printWindow.document.open();
  //   printWindow.document.write(legalPaperCss + updatedHtmlString);
  //   printWindow.document.close();
  //   printWindow.focus();

  //   function imagesLoaded(callback) {
  //     const images = printWindow.document.images;
  //     let loadedCount = 0;

  //     if (images.length === 0) {
  //       callback();
  //       return;
  //     }

  //     for (let i = 0; i < images.length; i++) {
  //       if (images[i].complete) {
  //         loadedCount++;
  //         if (loadedCount === images.length) {
  //           callback();
  //         }
  //       } else {
  //         images[i].addEventListener('load', () => {
  //           loadedCount++;
  //           if (loadedCount === images.length) {
  //             callback();
  //           }
  //         });
  //         images[i].addEventListener('error', () => {
  //           loadedCount++;
  //           if (loadedCount === images.length) {
  //             callback();
  //           }
  //         });
  //       }
  //     }
  //   }

  //   imagesLoaded(() => {
  //     printWindow.print();
  //     printWindow.close();
  //   });
  // };

  const handleChangeReferenceNumber = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <ChangeReferenceNumber
          transactionId={transId}
          onClear={handleClear}
          transactionInfo={paymentInfo}
        />
      ),
      title: 'Change Reference Number',
      modalSize: 'modal-md',
    });
  };

  const handlePostEgovPay = () => {
    postEgovPay({ refno: _.get(formData, 'refno') }, () => {
      handleFindPayment();
    });
  };

  const pStatus = _.get(paymentInfo, 'status');
  const tStatus = _.get(paymentInfo, 'transaction_status');

  const handleViewOR = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOR data={item} />,
      title: `View eOR`,
      modalSize: 'modal-xl',
    });
  };

  const handlePaymentPosting = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <PaymentPostingModal
          transactionInfo={paymentInfo}
          id={item.id}
          item={item}
        />
      ),
      title: `Check Posting`,
      modalSize: 'modal-md',
    });
  };

  // const handleRollbackPayment = () => {
  //   rollbackPayment({ transaction_history_id: _.get(item, 'id') }, () => {
  //     handleFindPayment();
  //   });
  // };

  const handleRollbackPayment = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <RollbackModal id={item.id} onClear={handleClear} />,
      title: `Rollback`,
      modalSize: 'modal-md',
    });
  };

  const handleChangeSelect = (key) => (e) => {
    const selectedValue = _.get(e, 'value', '') || '';
    const value = key === 'sort_by' && !selectedValue ? 'desc' : selectedValue;

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const selectedModuleType =
    c.MODULE_TYPES.find((option) => option.value === _.get(formData, 'module_type')) || null;
  const selectedStatus =
    c.TRANSACTION_STATUS.find((option) => option.value === _.get(formData, 'transaction_status')) ||
    null;
  const selectedSort =
    c.SORT_BY.find((option) => option.value === _.get(formData, 'sort_by')) || null;

  // const renderActionButton = () =>
  //   _.isEmpty(paymentInfo) ? (
  //     <button
  //       disabled={searching}
  //       type="submit"
  //       className="btn btn-primary cms-bg-color-primary cms-outline-primary"
  //       style={{ minWidth: '90px' }}
  //     >
  //       {searching ? <i className="fa fa-spin fa-spinner" /> : <>Verify <i className="fas fa-check" /></>}
  //     </button>
  //   ) : (
  //     <button
  //       onClick={handleClear}
  //       type="button"
  //       className="btn btn-danger"
  //       style={{ minWidth: '90px' }}
  //     >
  //       CLEAR <i className="fas fa-times" />
  //     </button>
  //   );

  const renderFilterButton = () => (
    <button
      disabled={searching}
      type="button"
      onClick={handleFilter}
      className="btn btn-primary cms-bg-color-primary cms-outline-primary"
      style={{ minWidth: '90px' }}
    >
      {searching ? <i className="fa fa-spin fa-spinner" /> : <>Filter <i className="fas fa-filter" /></>}
    </button>
  );

  const renderModuleTypeSelect = () => (
    <Select
      isClearable
      name="module_type"
      placeholder="Select Module Type"
      onChange={handleChangeSelect('module_type')}
      options={c.MODULE_TYPES}
      value={selectedModuleType}
      // styles={moduleTypeSelectStyles}
    />
  );
  const renderStatusesSelect = () => (
    <Select
      isClearable
      name="transaction_status"
      placeholder="Select Status"
      onChange={handleChangeSelect('transaction_status')}
      options={c.TRANSACTION_STATUS}
      value={selectedStatus}
    />
  );
  const renderSort = () => (
    <Select
      // isClearable
      name="sort_by"
      placeholder="Sort by"
      onChange={handleChangeSelect('sort_by')}
      options={c.SORT_BY}
      value={selectedSort}
    />
  );

  const renderTbody = () => {
    if (isLoading) {
      return (
        <tr
          className="text-muted font-italic text-sm text-center py-5"
          style={{
            display: 'table',
            width: '100%',
            tableLayout: 'fixed',
            height: '100%',
          }}
        >
          <td colSpan={5}>Loading...</td>
        </tr>
      );
    }

    if (_.isEmpty(findPaymentList)) {
      return (
        <tr
          className="text-muted font-italic text-sm text-center"
          style={{
            display: 'table',
            width: '100%',
            tableLayout: 'fixed',
          }}
        >
          <td colSpan={5}>No Payment Available...</td>
        </tr>
      );
    }

    return findPaymentList.map((row, index) => {
      const getModuleType = () => {
        const moduleType = _.get(row, 'attributes.module_type');
        
        if (moduleType === 'PSA' || moduleType === 'DC' || moduleType === 'MC') {
          return 'CIVIL REGISTRY';
        }
        if (moduleType === 'CDL') {
          return 'CEDULA';
        }
        if (moduleType === 'BPLS') {
          return 'BPLS';
        }
        return 'N/A';
      };

      return (
        <tr
          key={_.get(row, 'id') || index}
          style={{
            display: 'table',
            width: '100%',
            tableLayout: 'fixed',
          }}
        >
          <td>{moment(_.get(row, 'attributes.updated_at')).format('MMMM DD, YYYY HH:mm') || 'N/A'}</td>
          <td>{getModuleType(_.get(row, 'attributes.module_type')) || 'N/A'}</td>
          <td>{_.get(row, 'attributes.txnid') || 'N/A'}</td>
          <td>{_.get(row, 'attributes.transaction_type') || 'N/A'}</td>
          <td>{_.get(row, 'attributes.entity') || 'N/A'}</td>
          <td>{_.get(row, 'attributes.taxpayer_name') || 'N/A'}</td>
          <td>{_.get(row, 'attributes.amount') ? `₱ ${_.get(row, 'attributes.amount')}` : 'N/A'}</td>
          <td>{_.get(row, 'attributes.display_status') || 'N/A'}
          </td>
          <td className="text-right">
            <button
              type="button"
              onClick={handleViewFindPayment(row)}
              className="btn btn-sm btn-primary cms-bg-color-primary cms-outline-primary"
            >
              View Info
            </button>
          </td>
        </tr>
      )
    })
  };

  return (
    <div className="h-100" style={{ paddingTop: '5rem', marginTop: '-5rem' }}>
      <div className="p-5"
        style={{ gap: '1rem' }}
      >
        <div className="d-flex flex-column h-100">
          <div className="flex-grow-1 d-flex flex-column w-100">
            <div className="payment">
              <div className="p-3">
                {/* <div className="my-3">
                  <form onSubmit={onFindPayment} className="border rounded p-2 bg-white shadow-sm">
                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                      <span className="font-weight-bold text-muted px-2">#</span>
                      <input
                        name="refno"
                        onChange={handleChange}
                        value={_.get(formData, 'refno') || ''}
                        type="text"
                        className="form-control"
                        placeholder="Enter REFERENCE NUMBER or TXNID"
                      />
                      {renderActionButton()}
                    </div>
                  </form>
                </div> */}
                {_.isEmpty(paymentInfo) && (
                // !_.isEmpty(findPaymentList) && _.isEmpty(paymentInfo) && (
                  <div className="payments__summary">
                    <div className="d-flex align-items-center justify-content-end mb-2" style={{ gap: '10px' }}>
                      <div className='mr-3' style={{ minWidth: '300px' }}>
                        <input
                          name="q"
                          onChange={handleChange}
                          value={_.get(formData, 'q') || ''}
                          type="text"
                          className="form-control"
                          placeholder="Enter REFERENCE NUMBER or TXNID"
                        />
                      </div>
                      <div style={{ minWidth: '210px' }}>{renderModuleTypeSelect()}</div>
                      <div style={{ minWidth: '210px' }}>{renderStatusesSelect()}</div>
                      <div style={{ minWidth: '210px' }}>{renderSort()}</div>
                      {renderFilterButton()}
                    </div>
                    <table className="table table-hover table-bordered mb-0 w-100" style={{ tableLayout: 'fixed' }}>
                      <thead
                        style={{
                          display: 'table',
                          width: '100%',
                          tableLayout: 'fixed',
                          backgroundColor: '#fff',
                        }}
                      >
                        <tr>
                          <th scope="col" className="font-weight-semibold text-center">DATE</th>
                          <th scope="col" className="font-weight-semibold text-center">MODULE</th>
                          <th scope="col" className="font-weight-semibold text-center">TRANSACTION ID</th>
                          <th scope="col" className="font-weight-semibold text-center">TRANSACTION TYPE</th>
                          <th scope="col" className="font-weight-semibold text-center">ENTITY</th>
                          <th scope="col" className="font-weight-semibold text-center">APPLICANT</th>
                          <th scope="col" className="font-weight-semibold text-center">AMOUNT</th>
                          <th scope="col" className="font-weight-semibold text-center">STATUS</th>
                          <th className="font-weight-semibold text-center">ACTION</th>
                        </tr>
                      </thead>
                      <tbody
                        className="hide-scrollbar"
                        style={{
                          display: 'block',
                          maxHeight: 'calc(100vh - 340px)',
                          overflowY: 'auto',
                          width: '100%',
                          scrollbarWidth: 'none',
                          msOverflowStyle: 'none',
                        }}
                      >
                        {renderTbody()}
                      </tbody>
                    </table>
                    {/* </div> */}
                    <div className="p-3 border border-top-0">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="text-muted font-italic text-sm mb-0">
                          Showing {findPaymentList.length} of {findPaymentPager.total} entries
                        </p>
                        {findPaymentPager.total_pages > 1 && (
                          <Pagination
                            data={findPaymentPager}
                            onChange={handleChangeFindPaymentPage}
                            isLoading={searching}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )} 
                {!_.isEmpty(paymentInfo) && (
                  <div className="payments__summary">
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn btn-link text-dark p-0"
                        onClick={handleBackToList}
                      >
                        <i className="fas fa-arrow-left" />
                      </button>
                      <div className="payments__summary-title flex-grow-1 mb-0">
                        TRANSACTION SUMMARY
                      </div>
                    </div>
                    <hr className="stiches" />
                    <table className="table borderless">
                      <tbody>
                        <tr>
                          <td>
                            <b>Permit Type:</b>
                          </td>
                          <td className="text-right">
                            {_.get(paymentInfo, 'permit_type') || 'N/A'}
                          </td>
                        </tr>
                        {isNewRenew ? (
                          <tr>
                            <td>
                              <b>Barangay Business Clearance Status:</b>
                            </td>
                            <td className="text-right">
                              {taxpayerInfoBrgyClearanceStatus || 'N/A'}
                            </td>
                          </tr>
                        ) : null}
                        <tr>
                          <td>
                            <b>Transaction Type:</b>
                          </td>
                          <td className="text-right">
                            {_.get(paymentInfo, 'transaction_type') || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Status:</b>
                          </td>
                          <td className="text-right">
                            {tStatus === 'WAITING FOR PAYMENT'
                              ? 'READY FOR POSTING'
                              : pStatus || 'PENDING'}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Full Name:</b>
                          </td>
                          <td className="text-right">
                            {_.get(paymentInfo, 'name') || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Email:</b>
                          </td>
                          <td className="text-right">
                            {_.get(paymentInfo, 'email') || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>TXNID:</b>
                          </td>
                          <td className="text-right">
                            {_.get(paymentInfo, 'txnid') || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Contact Number:</b>
                          </td>
                          <td className="text-right">
                            {`+${_.get(paymentInfo, 'mobile_number')}` || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Payment Channel:</b>
                          </td>
                          <td className="text-right">
                            {_.get(paymentInfo, 'payment_channel') || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Reference Number:</b>
                          </td>
                          <td className="text-right">
                            {_.get(paymentInfo, 'refno') || 'N/A'}
                          </td>
                        </tr>
                        {taxPayerInfoIsPosted?.is_posted === undefined ? null : (
                          <tr>
                            <td>
                              <b>Payment Posted:</b>
                            </td>
                            <td className="text-right">
                              {taxPayerInfoIsPosted?.is_posted === 0 ? 'No' : 'Yes'}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>
                            <b>Amount:</b>
                          </td>
                          <td className="text-right">
                            <b>{_.get(paymentInfo, 'amount') || 'N/A'}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>OR Number:</b>
                          </td>
                          <td className="text-right">
                            {_.get(paymentInfo, 'or_number') || 'N/A'}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Transaction Status:</b>
                          </td>
                          <td className="text-right">
                            <b>{tStatus || 'N/A'}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Remarks:</b>
                          </td>
                          <td className="text-right">
                            <pre>{_.get(paymentInfo, 'remarks') || 'N/A'}</pre>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="for-posting-wrap payment-button-container">
                      {_.get(paymentInfo, 'payment_channel') !== 'MANUAL PAYMENT' &&
                        _.get(paymentInfo, 'payment_receipt_url') &&
                        Acl(permissions, ['PAYMENT VIEW RECEIPT']) && (
                          <button
                            type="button"
                            className="btn btn-outline-primary w-100 mb-2"
                            onClick={handleViewReceipt(
                              _.get(paymentInfo, 'payment_receipt_url')
                            )}
                          >
                            <b>View Payment Receipt</b>
                          </button>
                        )}
                      {Acl(permissions, ['PAYMENT VIEW LOGS']) && (
                        <button
                          onClick={handleViewPaymentLogs}
                          type="button"
                          className="btn btn-outline-primary mb-2 w-100"
                        >
                          {findingLogs ? (
                            <>
                              <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                            </>
                          ) : (
                            <b>View Payment Logs</b>
                          )}
                        </button>
                      )}
                      {_.get(paymentInfo, 'payment_channel') !== 'MANUAL PAYMENT' &&
                        Acl(permissions, ['PAYMENT CHANGE TXNID']) && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mb-2 w-100"
                            onClick={handleChangeTxn}
                          >
                            {findingLogsForTxn ? (
                              <>
                                <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                              </>
                            ) : (
                              <b>Change TXNID</b>
                            )}
                          </button>
                        )}
                      {_.get(paymentInfo, 'payment_channel') !== 'MANUAL PAYMENT' &&
                        _.get(paymentInfo, 'module_type') === 'NOV' &&
                        taxPayerInfoIsPosted.is_posted === 0 && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mb-2 w-100"
                            onClick={handlePostPaymentToQpax}
                          >
                            <b>Post Payment To QPAX</b>
                          </button>
                        )}

                      {(Acl(permissions, ['PAYMENT TAG FOR POSTING']) &&
                        _.get(paymentInfo, 'payment_channel') !== 'MANUAL PAYMENT' &&
                        tStatus === 'EXPIRED REFERENCE NUMBER') ||
                        tStatus === 'PENDING' ||
                        pStatus === 'PENDING' ||
                        !pStatus ? (
                          <button
                            onClick={handleTagforPosting}
                            type="button"
                            className="btn btn-outline-primary w-100"
                          >
                            {posting ? (
                              <>
                                <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                              </>
                            ) : (
                              <b>Tag as for Posting</b>
                            )}
                          </button>
                        ) : (
                          ''
                        )}
                      {(Acl(permissions, ['PAYMENT EXPIRE']) &&
                        _.get(paymentInfo, 'payment_channel') !== 'MANUAL PAYMENT' &&
                        tStatus === 'PENDING') ||
                        tStatus === 'WAITING FOR PAYMENT' ||
                        !pStatus ? (
                          <button
                            type="button"
                            className="btn btn-outline-primary w-100 mt-2"
                            onClick={handleManualExpireRefno}
                          >
                            <b>Expire Reference Number</b>
                          </button>
                        ) : (
                          ''
                        )}
                      {_.get(paymentInfo, 'payment_channel') !== 'MANUAL PAYMENT' &&
                      tStatus === 'FOR REFUND APPROVAL' ? (
                        <button
                          type="button"
                          className="btn btn-outline-primary w-100 mt-2"
                          onClick={handleApproveRefund}
                        >
                          {refunding ? (
                            <>
                              <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                            </>
                          ) : (
                            <b>Approve Refund Request</b>
                          )}
                        </button>
                      ) : (
                        ''
                      )}
                      {/* {_.get(paymentInfo, 'payment_channel') !== 'MANUAL PAYMENT' &&
                        !_.get(paymentInfo, 'paid_at') &&
                        Acl(permissions, ['PAYMENT CHANGE AMOUNT']) && (
                          <button
                            type="button"
                            className="btn btn-outline-primary w-100 mt-2"
                            onClick={handleChangeAmount}
                          >
                            {findingLogsForAmount ? (
                              <>
                                <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                              </>
                            ) : (
                              <b>Change Amount</b>
                            )}
                          </button>
                        )} */}
                      {_.get(CMS_VARIABLES, 'SYSTEM_STATUS') !== 'LIVE' &&
                      _.isEmpty(_.get(CMS_VARIABLES, 'LIVE_DATE'))
                        ? Acl(permissions, ['PAYMENT BPLS CHANGE YEAR']) &&
                          _.get(paymentInfo, 'module_type') === 'BPLS' &&
                          (_.get(paymentInfo, 'transaction_type') === 'NEW' ||
                            _.get(paymentInfo, 'transaction_type') === 'CHANGE') && (
                            <button
                              type="button"
                              className="btn btn-outline-primary mt-2 w-100"
                              onClick={handleChangeYear}
                            >
                              <b>Change Year</b>
                            </button>
                          )
                        : ''}
                      {_.get(CMS_VARIABLES, 'SYSTEM_STATUS') !== 'LIVE' &&
                      _.isEmpty(_.get(CMS_VARIABLES, 'LIVE_DATE'))
                        ? Acl(permissions, ['PAYMENT BPLS CHANGE QUARTER']) &&
                          _.get(paymentInfo, 'module_type') === 'BPLS' &&
                          (_.get(paymentInfo, 'transaction_type') === 'RENEWAL' ||
                            _.get(paymentInfo, 'transaction_type') === 'QUARTERLY') && (
                            <button
                              type="button"
                              className="btn btn-outline-primary mt-2 w-100"
                              onClick={handleChangeQuarter}
                            >
                              <b>Change Quarter</b>
                            </button>
                          )
                        : ''}
                      {Acl(permissions, ['PAYMENT MANUAL PAYMENT']) &&
                        (tStatus === 'FOR PAYMENT CONFIRMATION' ||
                          tStatus === 'WAITING FOR PAYMENT' ||
                          tStatus === 'PENDING') && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mt-2 w-100"
                            onClick={handleChangeManualPayment}
                          >
                            <b>Set Payment</b>
                          </button>
                        )}
                      {Acl(permissions, ['PAYMENT CHANGE REFERENCE NUMBER']) &&
                        _.get(paymentInfo, 'payment_channel') === 'MANUAL PAYMENT' &&
                        _.get(paymentInfo, 'paid_at') && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mt-2 w-100"
                            onClick={handleChangeReferenceNumber}
                          >
                            <b>Update Reference Number</b>
                          </button>
                        )}
                      {/* {Acl(permissions, ['PAYMENT CHANGE REFERENCE NUMBER']) &&
                        _.get(paymentInfo, 'payment_channel') === 'MANUAL PAYMENT' &&
                        _.get(paymentInfo, 'paid_at') && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mt-2 w-100"
                            onClick={handleViewOr}
                          >
                            <b>View OR</b>
                          </button>
                        )} */}
                      {Acl(permissions, ['PAYMENT MANAGE OR']) &&
                        _.get(paymentInfo, 'permit_type') !==
                          'Community Tax Certificate CTC / CEDULA' &&
                        _.get(paymentInfo, 'permit_type') !== 'Local Civil Registry' &&
                        _.get(paymentInfo, 'paid_at') && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mt-2 w-100"
                            onClick={() => {
                              history.push(`official_receipts/${transId}`);
                            }}
                          >
                            <b>View Official Receipts</b>
                          </button>
                        )}
                      {Acl(permissions, ['PAYMENT MANAGE OR']) &&
                        _.get(paymentInfo, 'permit_type') !==
                          'Community Tax Certificate CTC / CEDULA' &&
                        _.get(paymentInfo, 'permit_type') !==
                          'Business Permit and License Application (BPLS)' &&
                        _.get(paymentInfo, 'paid_at') && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mt-2 w-100"
                            onClick={() => {
                              history.push(`official_receipts/${transId}`);
                            }}
                          >
                            <b>View Official Receipts</b>
                          </button>
                        )}
                      {Acl(permissions, ['PAYMENTS VIEW E-OR']) &&
                        // _.get(paymentInfo, 'payment_type') === 'ONLINE' &&
                        _.get(paymentInfo, 'paid_at') && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mt-2 w-100"
                            onClick={handleViewOR}
                          >
                            <b>View eOR</b>
                          </button>
                        )}
                      {Acl(permissions, ['PAYMENT EGOVPAY MANUAL POSTING']) &&
                        tStatus === 'WAITING FOR PAYMENT' &&
                        !_.get(paymentInfo, 'paid_at') && (
                          <button
                            type="button"
                            className="btn btn-outline-primary mt-2 w-100"
                            onClick={handlePostEgovPay}
                          >
                            {isPostingEgovPay ? (
                              <>
                                <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                              </>
                            ) : (
                              <b>Post eGovPay Payment</b>
                            )}
                          </button>
                        )}

                      {Acl(permissions, ['CHECK PAYMENT POSTING']) &&
                        ['EXPIRED SOA'].indexOf(
                          _.get(item, 'included.bplsApplication.attributes.status')
                        ) === -1 &&
                        [
                          'PENDING',
                          'WAITING FOR PAYMENT',
                          'EXPIRED REFERENCE NUMBER',
                        ].indexOf(_.get(item, 'attributes.transaction_status')) > -1 && (
                          <button
                            onClick={handlePaymentPosting}
                            className="btn btn-outline-primary mt-2 w-100"
                            type="button"
                          >
                            <b>Check Payment Posting</b>
                          </button>
                        )}

                      {Acl(permissions, ['ROLLBACK PAYMENT']) &&
                        ['ISSUED', 'FOR PICK-UP', 'FOR PRINTING'].indexOf(
                          _.get(item, 'attributes.transaction_status')
                        ) > -1 &&
                        _.get(paymentInfo, 'payment_channel') === 'MANUAL PAYMENT' && (
                          // ['NEW', 'RENEWAL'].indexOf(
                          //   _.get(item, 'attributes.transaction_type')
                          // ) > -1 &&
                          // _.get(item, 'attributes.permit_type') ===
                          //   'Business Permit and License Application (BPLS)' && (
                          <button
                            onClick={handleRollbackPayment}
                            className="btn btn-outline-primary mt-2 w-100"
                            type="button"
                          >
                            <b>Rollback Payment</b>
                          </button>
                        )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
}

PaymentInquiryContainer.propTypes = {
  findPayment: PropTypes.instanceOf(Function).isRequired,
  tagAsForPosting: PropTypes.instanceOf(Function).isRequired,
  viewPaymentLogs: PropTypes.instanceOf(Function).isRequired,
  viewPaymentLogsForTxn: PropTypes.instanceOf(Function).isRequired,
  searching: PropTypes.bool.isRequired,
  posting: PropTypes.bool.isRequired,
  findingLogs: PropTypes.bool.isRequired,
  findingLogsForTxn: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  postPaymentToQpax: PropTypes.instanceOf(Function).isRequired,
  manualExpireRefno: PropTypes.instanceOf(Function).isRequired,
  approveRefund: PropTypes.instanceOf(Function).isRequired,
  refunding: PropTypes.bool.isRequired,
  viewPaymentLogsForAmount: PropTypes.instanceOf(Function).isRequired,
  findingLogsForAmount: PropTypes.bool.isRequired,
  postEgovPay: PropTypes.instanceOf(Function).isRequired,
  isPostingEgovPay: PropTypes.bool.isRequired,
  getListCms: PropTypes.instanceOf(Function).isRequired,
  getPaperList: PropTypes.instanceOf(Function).isRequired,
  // itemHtml: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  rollbackPayment: PropTypes.instanceOf(Function).isRequired,
  getFeeOptionList: PropTypes.instanceOf(Function).isRequired,
  getFindPaymentList: PropTypes.instanceOf(Function).isRequired,
  findPaymentList: PropTypes.instanceOf(Array).isRequired,
  findPaymentPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  findPaymentById: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  searching: api.loading.indexOf(c.FIND_PAYMENT) > -1,
  posting: api.loading.indexOf(c.TAG_FOR_POSTING) > -1,
  findingLogs: api.loading.indexOf(c.VIEW_PAYMENT_LOGS) > -1,
  findingLogsForTxn: api.loading.indexOf(c.VIEW_PAYMENT_LOGS_FOR_TXNID) > -1,
  refunding: api.loading.indexOf(c.APPROVE_REFUND) > -1,
  permissions: getJson('permissions'),
  findingLogsForAmount:
    api.loading.indexOf(c.VIEW_PAYMENT_LOGS_FOR_AMOUNT) > -1,
  isPostingEgovPay: api.loading.indexOf(c.POST_EGOV_PAY) > -1,
  findPaymentList: _.get(api, `${c.GET_FIND_PAYMENT_LIST}.list`) || [],
  findPaymentPager: _.get(api, `${c.GET_FIND_PAYMENT_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_FIND_PAYMENT_LIST) > -1,
  // itemPaperHtml:
  //   (_.get(api, `${'CMS/get_paper_settings'}.list`) || [])[0] || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(PaymentInquiryContainer);
